<template>
  <div class="box flex-row">
    <div :class="xwt?'fl':''">
      <span v-if="!xwt">正面</span>
      <div class="body_box" :class="xwt ? '' : ''">
        <img :src="body" alt="" />
      
        <div
          class="point fl"
          :class="{ select: item.is_select }"
          :style="{ left: item.x, top: item.y }"
          v-for="(item, index) in front"
          :key="item.No"
          @click="selectItem(index, item, 1)"
        ></div>
        
      </div>
      
    </div>
    <div :class="xwt?'fl':''">
      <span  v-if="!xwt">反面</span>
      <div class="body_box back" :class="xwt ? '' : ''">
        <img :src="body2" alt="" />
       
        <div
          class="point"
          :class="{ select: itemB.is_select }"
          :style="{ left: itemB.x, top: itemB.y }"
          v-for="(itemB, indexB) in back"
          :key="itemB.No"
          @click="selectItem(indexB, itemB, 2)"
        ></div>
      </div>
    </div>
    <div v-if="xwt" class="zm">
      <div class="tian_ms colorW ">
      <div class="clear mt20">
        <text class="title fl">正面</text>
        <text class="content fl">
          <text class="mb10" :key="item.No" v-for="item in selectFork">{{
            item
          }}</text>
        </text>
      </div>
    </div>
    <div class="tian_ms colorW">
      <div class="clear mt20">
        <text class="title fl">反面</text>
        <text class="content fl">
          <text class="mb10" :key="item.No" v-for="item in selectBack">{{
            item
          }}</text>
        </text>
      </div>
    </div>
   
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectItemS: {
      type: [Object, Array],
      default: () => [],
    },
    disabled:{
      type:Boolean,
      default:false
    },
    xwt:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      // xwt: true,
      body: require("@/assets/xxp-img/body.png"),
      body2: require("@/assets/xxp-img/body_2.png"),
      front: [
        {
          No: 1,
          x: "50%",
          y: "7%",
          is_select: false,
        },
        {
          No: 2,
          x: "50%",
          y: "18%",
          is_select: false,
        },
        {
          No: 3,
          x: "38%",
          y: "22%",
          is_select: false,
        },
        {
          No: 4,
          x: "33%",
          y: "35%",
          is_select: false,
        },
        {
          No: 5,
          x: "28%",
          y: "50%",
          is_select: false,
        },
        {
          No: 6,
          x: "62%",
          y: "22%",
          is_select: false,
        },
        {
          No: 7,
          x: "67%",
          y: "35%",
          is_select: false,
        },
        {
          No: 8,
          x: "72%",
          y: "50%",
          is_select: false,
        },
        {
          No: 9,
          x: "50%",
          y: "40%",
          is_select: false,
        },
        {
          No: 10,
          x: "42%",
          y: "48%",
          is_select: false,
        },
        {
          No: 11,
          x: "40%",
          y: "58%",
          is_select: false,
        },
        {
          No: 12,
          x: "42%",
          y: "68%",
          is_select: false,
        },
        {
          No: 13,
          x: "42%",
          y: "75%",
          is_select: false,
        },
        {
          No: 14,
          x: "42%",
          y: "90%",
          is_select: false,
        },
        {
          No: 15,
          x: "58%",
          y: "48%",
          is_select: false,
        },
        {
          No: 16,
          x: "60%",
          y: "58%",
          is_select: false,
        },
        {
          No: 17,
          x: "58%",
          y: "68%",
          is_select: false,
        },
        {
          No: 18,
          x: "58%",
          y: "75%",
          is_select: false,
        },
        {
          No: 19,
          x: "58%",
          y: "90%",
          is_select: false,
        },
      ],
      back: [
        {
          No: 1,
          x: "51.5%",
          y: "7%",
          is_select: false,
        },
        {
          No: 2,
          x: "51.5%",
          y: "18%",
          is_select: false,
        },
        {
          No: 3,
          x: "40%",
          y: "24%",
          is_select: false,
        },
        {
          No: 4,
          x: "32%",
          y: "40%",
          is_select: false,
        },
        {
          No: 5,
          x: "24%",
          y: "55%",
          is_select: false,
        },
        {
          No: 6,
          x: "60%",
          y: "24%",
          is_select: false,
        },
        {
          No: 7,
          x: "70%",
          y: "40%",
          is_select: false,
        },
        {
          No: 8,
          x: "78%",
          y: "55%",
          is_select: false,
        },
        {
          No: 9,
          x: "51.5%",
          y: "33%",
          is_select: false,
        },
        {
          No: 10,
          x: "51.5%",
          y: "43%",
          is_select: false,
        },
        {
          No: 11,
          x: "45%",
          y: "50%",
          is_select: false,
        },
        {
          No: 12,
          x: "45%",
          y: "61%",
          is_select: false,
        },
        {
          No: 13,
          x: "45%",
          y: "69%",
          is_select: false,
        },
        {
          No: 14,
          x: "45%",
          y: "80%",
          is_select: false,
        },
        {
          No: 15,
          x: "47%",
          y: "95%",
          is_select: false,
        },
        {
          No: 16,
          x: "58%",
          y: "50%",
          is_select: false,
        },
        {
          No: 17,
          x: "58%",
          y: "61%",
          is_select: false,
        },
        {
          No: 18,
          x: "58%",
          y: "69%",
          is_select: false,
        },
        {
          No: 19,
          x: "58%",
          y: "80%",
          is_select: false,
        },
        {
          No: 20,
          x: "57%",
          y: "95%",
          is_select: false,
        },
      ],
      front1: [
        {
          No: 1,
          x: "50%",
          y: "7%",
          name: "头",
          is_select: false,
        },
        {
          No: 2,
          x: "50%",
          y: "18%",
          name: "颈",
          is_select: false,
        },
        {
          No: 3,
          x: "38%",
          name: "右肩",
          y: "22%",
          is_select: false,
        },
        {
          No: 4,
          x: "33%",
          name: "右手肘",
          y: "35%",
          is_select: false,
        },
        {
          No: 5,
          x: "28%",
          y: "50%",
          name: "右手掌",
          is_select: false,
        },
        {
          No: 6,
          x: "62%",
          y: "22%",
          name: "左肩",
          is_select: false,
        },
        {
          No: 7,
          name: "左手肘",
          x: "67%",
          y: "35%",

          is_select: false,
        },
        {
          No: 8,
          x: "72%",
          name: "左手掌",
          y: "50%",
          is_select: false,
        },
        {
          No: 9,
          name: "肚子",
          x: "50%",
          y: "40%",
          is_select: false,
        },
        {
          No: 10,
          name: "右髋骨",
          x: "42%",
          y: "48%",
          is_select: false,
        },
        {
          No: 11,
          x: "40%",
          name: "右大腿",
          y: "58%",
          is_select: false,
        },
        {
          No: 12,
          x: "42%",
          name: "右膝盖",
          y: "68%",
          is_select: false,
        },
        {
          No: 13,
          x: "42%",
          y: "75%",
          name: "右小腿",
          is_select: false,
        },
        {
          No: 14,
          x: "42%",
          y: "90%",
          name: "右足",
          is_select: false,
        },
        {
          name: "左髋骨",
          No: 15,
          x: "58%",
          y: "48%",
          is_select: false,
        },
        {
          No: 16,
          x: "60%",
          name: "左大腿",
          y: "58%",
          is_select: false,
        },
        {
          No: 17,
          x: "58%",
          name: "左膝盖",
          y: "68%",
          is_select: false,
        },
        {
          No: 18,
          x: "58%",
          y: "75%",
          name: "左小腿",
          is_select: false,
        },
        {
          No: 19,
          x: "58%",
          y: "90%",
          name: "左足",
          is_select: false,
        },
      ],
      back1: [
        {
          No: 1,
          x: "51.5%",
          y: "7%",
          name: "头",
          is_select: false,
        },
        {
          No: 2,
          x: "51.5%",
          name: "颈",
          y: "18%",
          is_select: false,
        },
        {
          No: 3,
          x: "30%",
          y: "24%",
          name: "左肩",
          is_select: false,
        },
        {
          No: 4,
          x: "24%",
          name: "左手肘",
          y: "40%",
          is_select: false,
        },
        {
          No: 5,
          x: "14%",
          name: "左手掌",
          y: "55%",
          is_select: false,
        },
        {
          No: 6,
          x: "76%",
          name: "右肩",
          y: "24%",
          is_select: false,
        },
        {
          No: 7,
          name: "右手肘",
          x: "80%",
          y: "40%",
          is_select: false,
        },
        {
          No: 8,
          x: "88%",
          y: "55%",
          name: "右手掌",
          is_select: false,
        },
        {
          No: 9,
          name: "背",
          x: "51.5%",
          y: "30%",
          is_select: false,
        },
        {
          No: 10,
          name: "腰",
          x: "51.5%",
          y: "43%",
          is_select: false,
        },
        {
          No: 11,
          x: "42%",
          name: "左臀",
          y: "48%",
          is_select: false,
        },
        {
          No: 12,
          name: "左大腿",
          x: "42%",
          y: "61%",
          is_select: false,
        },
        {
          No: 13,
          name: "左膝盖",
          x: "42%",
          y: "69%",
          is_select: false,
        },
        {
          No: 14,
          x: "45%",
          y: "80%",
          name: "左小腿",
          is_select: false,
        },
        {
          No: 15,
          x: "45%",
          y: "95%",
          name: "左足",
          is_select: false,
        },
        {
          No: 16,
          name: "右臀",
          x: "63%",
          y: "48%",
          is_select: false,
        },
        {
          No: 17,
          x: "63%",
          name: "右大腿",
          y: "61%",
          is_select: false,
        },
        {
          No: 18,
          x: "62%",
          name: "右膝盖",
          y: "69%",
          is_select: false,
        },
        {
          No: 19,
          x: "64%",
          name: "右小腿",
          y: "80%",
          is_select: false,
        },
        {
          No: 20,
          name: "右足",
          x: "58%",
          y: "95%",
          is_select: false,
        },
      ],
    };
  },
  computed: {
    selectBack() {
      return this.back
        .filter((item) => item.is_select)
        .map((item) => item.name);
    },
    selectFork() {
      return this.front
        .filter((item) => item.is_select)
        .map((item) => item.name);
    },
  },
  watch: {
    selectItemS: {
      deep: true, //true为进行深度监听,false为不进行深度监听
      handler(newVal) {
        this.updatas();
      },
    },
  },
  mounted() {
    this.updatas();
    this.extractName();
  },
  methods: {
    //
    extractName() {
      this.front.forEach((item) => {
        this.front1.forEach((ite) => {
          if (item.No === ite.No) {
            item.name = ite.name;
          }
        });
      });
      this.back.forEach((item) => {
        this.back1.forEach((ite) => {
          if (item.No === ite.No) {
            item.name = ite.name;
          }
        });
      });
    },
    updatas() {
      if (this.selectItemS[0]) {
        if (Array.isArray(this.selectItemS[0].answers)) {
          let forward = this.selectItemS[0].answers.filter(
            (item) => item.type === "forward"
          )[0];
          let back = this.selectItemS[0].answers.filter(
            (item) => item.type === "back"
          )[0];
          for (let i of this.front) {
            for (let j of forward.keyPoints) {
              if (j === i.No) {
                i.is_select = true;
              }
            }
          }
          for (let i of this.back) {
            for (let j of back.keyPoints) {
              if (j === i.No) {
                i.is_select = true;
              }
            }
          }
        }
      }
    },
    selectItem(index, item, type) {
      if(this.disabled) return
      if (type == 1) {
        this.front[index].is_select = !this.front[index].is_select;
      } else {
        this.back[index].is_select = !this.back[index].is_select;
      }
      // 对数据进行处理，把选中的传过去
      let obj = {
        forward: [],
        back: [],
      };
      obj.forward = this.front.filter((res) => res.is_select == true);
      obj.back = this.back.filter((res) => res.is_select == true);
      console.log(obj);
      this.$emit("selectBody", obj);
    },
  },
};
</script>

<style lang="less" scoped>
.element::-webkit-scrollbar {
  width: 0 !important;
}

.tian_ms {
  margin-top: 30px;
  .title {
    height: 168px;
    width: 32px;
    text-align: center;
    line-height: 32px;
    writing-mode: vertical-rl;
    // padding: 54px 20px;
    background: linear-gradient(180deg, #409af2, #2c6ff8);
    display: inline-block;
  }
  .content {
    width: 118px;
    text-align: center;
    background-color: #5e668d;
    height: 168px;
    overflow-y: scroll;

    text {
      display: block;
      margin-top: 10px;
      width: 100%;
    }
  }
}
.body_box {
  width: 310px;
  height: 465px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .point {
    width: 15px;
    height: 15px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
  }
  .select {
    background: #f468a2;
  }
}
.back {
  .point {
    background: rgba(255, 255, 255, 0.6);
  }
  .select {
    background: #f468a2;
  }
}
.zm{
  position: absolute;
  left: 233px;
    top: 50px;

}
.flex-row{
  position: relative;
}
</style>